import {
    Button,
    Grid,
    InputAdornment,
    Paper,
    TextField
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import LocationOnIcon from '@mui/icons-material/LocationOnOutlined';

interface SearchAndFilterSectionProps {
    searchQuery: string;
    setSearchQuery: (query: string) => void;
    location: string;
    setLocation: (location: string) => void;
}

export const SearchAndFilterSection = ({ searchQuery, setSearchQuery, location, setLocation }: SearchAndFilterSectionProps) => (
    <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={5}>
                <TextField
                    fullWidth
                    placeholder="Enter Keywords"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    size="small"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <Grid item xs={12} md={5}>
                <TextField
                    fullWidth
                    placeholder="Enter location"
                    size="small"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <LocationOnIcon />
                            </InputAdornment>
                        ),
                    }}
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                />
            </Grid>
            <Grid item xs={12} md={2}>
                <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    size="small"
                    sx={{ backgroundColor: 'primary.main', height: 1 }}
                >
                    SEEK
                </Button>
            </Grid>
        </Grid>
    </Paper>
); 